import { modalType, convertModalType } from '../../util/ModalUtil';
import { useEffect, useState, useRef } from 'react';
import CodeUtil from '../../util/CodeUtil';
import { CODE_GROUP_ID } from '../../constant/Constant';
import { InfoTxt, ModalHeader } from '../../component/ModalRef';
import SelectionBox from '../../component/SelectionBox';
import DatePickerBox from '../../component/DatePickerBox';

import { millis2StringDate, stringDate2Millis, millis2Date, date2Millis } from '../../util/TimeTableUtil';
import { useDispatch } from 'react-redux';
import { actionAdd, actionEdit } from '../../module/body/system/SystemTermModule';
import SwitchBox from '../../component/SwitchBox';

import CancelButtonBox from '../../component/buttons/CancelButtonBox';
import ConfirmButtonBox from '../../component/buttons/ConfirmButtonBox';
import DateTimePickerBox from '../../component/DateTimePickerBox';
import NullCheckUtil from '../../util/NullCheckUtil';
import PopupRef from '../../component/PopupRef';

const calcSemesterType = () => {
    var date = new Date();
    switch (date.getMonth() + 1) {
        case 12:
        case 1:
        case 2:
            return 'SPRING';
        case 3:
        case 4:
        case 5:
            return 'SUMMER';
        case 6:
        case 7:
        case 8:
            return 'AUTUMN';
        case 9:
        case 10:
        case 11:
        default:
            return 'WINTER';
    }
};

/* 모달을 닫기 위해서 modalRef를 반드시 전달받아야 함 */
const SystemTermModal = ({ type, row, callback, modalRef }) => {
    const dispatch = useDispatch();
    const popupRef = useRef(null);
    // 변수 선언
    const [semesterId, setSemesterId] = useState('');
    const [semesterNm, setSemesterNm] = useState('');
    const [semesterYearCd, setSemesterYearCd] = useState(CodeUtil.getFirstCode(CODE_GROUP_ID.SEMESTER_YEAR));
    const [semesterTypeCd, setSemesterTypeCd] = useState(calcSemesterType());
    const [subjectRegEndMillis, setSubjectRegEndMillis] = useState();
    // 수강신청
    const [enrolmentReqBgnMillis, setEnrolmentReqBgnMillis] = useState();
    const [enrolmentReqEndMillis, setEnrolmentReqEndMillis] = useState();
    const [enrolmentValidEndMillis, setEnrolmentValidEndMillis] = useState();
    const [enrolmentRegEndMillis, setEnrolmentRegEndMillis] = useState();

    useEffect(() => {
        if (type == modalType.EDIT) {
            row && setSemesterId(row.semesterId);
            row && setSemesterYearCd(row.semesterYearCd);
            row && setSemesterTypeCd(row.semesterTypeCd);
            row && setSubjectRegEndMillis(row.subjectRegEndMillis);
            row && setEnrolmentReqBgnMillis(row.enrolmentReqBgnMillis);
            row && setEnrolmentReqEndMillis(row.enrolmentReqEndMillis);
            row && setEnrolmentValidEndMillis(row.enrolmentValidEndMillis);
            row && setEnrolmentRegEndMillis(row.enrolmentRegEndMillis);
        }
    }, []);

    useEffect(() => {
        setSemesterId(semesterYearCd + '-' + semesterTypeCd);
        if (
            semesterYearCd != undefined &&
            semesterYearCd != null &&
            semesterYearCd != '' &&
            semesterTypeCd != undefined &&
            semesterTypeCd != null &&
            semesterTypeCd != ''
        ) {
            setSemesterNm(
                CodeUtil.getCodeName(CODE_GROUP_ID.SEMESTER_YEAR, semesterYearCd) +
                    ' ' +
                    CodeUtil.getCodeName(CODE_GROUP_ID.SEMESTER_TYPE, semesterTypeCd),
            );
        }
    }, [semesterYearCd, semesterTypeCd]);

    const handleCancel = () => {
        modalRef.current.close();
    };

    const handleConfirm = () => {
        if (validateTermData() && validateTermOrder()) {
            if (type == modalType.ADD) {
                dispatch(
                    actionAdd({
                        data: {
                            semesterId,
                            semesterNm,
                            semesterYearCd,
                            semesterTypeCd,
                            subjectRegEndMillis,
                            enrolmentReqBgnMillis,
                            enrolmentReqEndMillis,
                            enrolmentValidEndMillis,
                            enrolmentRegEndMillis,
                        },
                        callback,
                    }),
                );
            } else {
                dispatch(
                    actionEdit({
                        data: {
                            semesterId,
                            semesterNm,
                            semesterYearCd,
                            semesterTypeCd,
                            subjectRegEndMillis,
                            enrolmentReqBgnMillis,
                            enrolmentReqEndMillis,
                            enrolmentValidEndMillis,
                            enrolmentRegEndMillis,
                        },
                        callback,
                    }),
                );
            }
        }
    };

    const validateTermData = () => {
        if (NullCheckUtil.isEmpty(enrolmentReqBgnMillis)) {
            popupRef.current.openAlert('수강신청 시작일을 선택해주세요.');
            return false;
        }
        if (NullCheckUtil.isEmpty(enrolmentReqEndMillis)) {
            popupRef.current.openAlert('수강신청 종료일을 선택해주세요.');
            return false;
        }
        if (NullCheckUtil.isEmpty(enrolmentValidEndMillis)) {
            popupRef.current.openAlert('수강신청 검증종료일을 선택해주세요.');
            return false;
        }
        if (NullCheckUtil.isEmpty(enrolmentRegEndMillis)) {
            popupRef.current.openAlert('수강신청 등록종료일을 선택해주세요.');
            return false;
        }
        return true;
    };

    const validateTermOrder = () => {
        if (checkWrongOrder(enrolmentReqBgnMillis, enrolmentReqEndMillis)) {
            popupRef.current.openAlert('수강신청 시작은 수강신청 종료 보다 먼저여야 합니다.');
            return false;
        }
        if (checkWrongOrder(enrolmentReqEndMillis, enrolmentValidEndMillis)) {
            popupRef.current.openAlert('수강신청 종료는 수강신청 검증종료 보다 같거나 먼저여야 합니다.');
            return false;
        }
        if (checkWrongOrder(enrolmentValidEndMillis, enrolmentRegEndMillis)) {
            popupRef.current.openAlert('수강신청 검증종료는 수강신청 등록종료 보다 같거나 먼저여야 합니다.');
            return false;
        }
        return true;
    };

    const checkWrongOrder = (before, after) => {
        if (NullCheckUtil.isEmpty(before) || NullCheckUtil.isEmpty(after)) {
            return false;
        } else {
            let beforeDate = millis2Date(before);
            let afterDate = millis2Date(after);
            return beforeDate > afterDate;
        }
    };

    // 타이틀 관련 수정 명확하도록 외부 변수로 처리 필요
    return (
        <>
            <ModalHeader title={type == modalType.ADD ? '학기정보 등록' : '학기정보 수정'} modalRef={modalRef} />
            <div className='modal-body'>
                <div className='con-inner SystemTermModal'>
                    <InfoTxt infoTxt={type == modalType.ADD ? '학기 정보를 등록합니다.' : '학기 정보를 수정합니다.'} />
                    <div>
                        <div className='form-box-row'>
                            <SelectionBox
                                title='학기년도'
                                options={CodeUtil.getCodes(CODE_GROUP_ID.SEMESTER_YEAR)}
                                // size='medium'
                                value={semesterYearCd}
                                onChange={(e) => setSemesterYearCd(e.target.value)}
                                useAll={false}
                                disabled={type == modalType.ADD ? false : true}
                            />
                            <SelectionBox
                                title='학기타입'
                                options={CodeUtil.getCodes(CODE_GROUP_ID.SEMESTER_TYPE)}
                                // size='medium'
                                value={semesterTypeCd}
                                onChange={(e) => setSemesterTypeCd(e.target.value)}
                                useAll={false}
                                disabled={type == modalType.ADD ? false : true}
                            />
                        </div>
                        <div className='form-box-row'>
                            <DateTimePickerBox
                                title='강의(개설과목) 등록종료'
                                value={subjectRegEndMillis && millis2Date(subjectRegEndMillis)}
                                onChange={(date) => setSubjectRegEndMillis(date2Millis(date))}
                            />
                        </div>
                        <div className='form-box-row'>
                            <DateTimePickerBox
                                title='수강신청 시작'
                                value={enrolmentReqBgnMillis && millis2Date(enrolmentReqBgnMillis)}
                                onChange={(date) => setEnrolmentReqBgnMillis(date2Millis(date))}
                            />
                            <DateTimePickerBox
                                title='수강신청 종료'
                                value={enrolmentReqEndMillis && millis2Date(enrolmentReqEndMillis)}
                                onChange={(date) => setEnrolmentReqEndMillis(date2Millis(date))}
                            />
                        </div>
                        <div className='form-box-row'>
                            <DateTimePickerBox
                                title='수강신청 검증종료'
                                value={enrolmentValidEndMillis && millis2Date(enrolmentValidEndMillis)}
                                onChange={(date) => setEnrolmentValidEndMillis(date2Millis(date))}
                            />
                            <DateTimePickerBox
                                title='수강신청 등록종료'
                                value={enrolmentRegEndMillis && millis2Date(enrolmentRegEndMillis)}
                                onChange={(date) => setEnrolmentRegEndMillis(date2Millis(date))}
                            />
                        </div>
                    </div>
                </div>
                <div className='modal-btn-wrap'>
                    <CancelButtonBox title='취소' onClick={(e) => handleCancel()} />
                    <ConfirmButtonBox title='확인' onClick={(e) => handleConfirm()} />
                </div>
            </div>
            <PopupRef ref={popupRef} />
        </>
    );
};

export default SystemTermModal;
